export enum AccessType {
  ONLY_ME = 'ONLY_ME',
  PUBLIC = 'PUBLIC',
  RESTRICTED = 'RESTRICTED'
}
